import * as React from 'react';
import RootAtom from './Root';
import { NodeTypes } from '@src/interfaces/nodes';
import Atoms from '@src/interpreter/_Atoms';
function RootComponent({ component, tilted }) {
    if (!component) {
        return null;
    }
    if (component.type === NodeTypes.Root) {
        return (React.createElement(RootAtom, { component: component, tilted: false, index: 0 }, component.order.map((id, index) => (React.createElement(Atoms, { key: id, component: component.children[id], parent: null, tilted: tilted, index: index })))));
    }
}
export default RootComponent;
